import CookieUtil from "../../utils/cookieUtil"
import { IMAGES_BASE_PATH } from "../../config/constants"
import moment from "moment-timezone";
import _ from "lodash"

interface Translation {
    key: string;
    title?: string;
    description?: string;
  }
  
  interface Speaker {
    first_name?: string;
    last_name?: string;
    profile_picture?: {
        key?: string;
    };
  }
  interface ScheduleItem {
    speaker?: Speaker;
    moderator?: Speaker;
    translations?: Translation[];
    start_time?: string;
    end_time?: string;
  }

class UserHelper {
    static getSelectedLanguageId() {
        return CookieUtil.readCookie('lang_name');
      }

    static  getUserId () {
      let user: any = CookieUtil.getCookie('user_info');
      if (_.isUndefined(user) || _.isEmpty(user) || !_.has(user, '_id'))
        return false;
      return user['_id'];
    };
    
    static getEventId  () {
      let eventId: any = CookieUtil.getCookie('event_id')
      return (_.isUndefined(eventId) || _.isNull(eventId)) ? false : eventId;
    };

    static saveUserdataInCookies(userdata: any) {
        if (userdata.profile_picture === null) {
            let defaultPic = {
                 id: 'default_user',
                 file_name: 'user_profile_image.jpg',
            }
            userdata.profile_picture = defaultPic
       }

       let data = {
            _id: userdata._id,
            first_name: userdata.first_name,
            last_name: userdata.last_name,
            phone: userdata.Phone,
            email: userdata.email,
            gender: userdata.gender,
            profile_picture: userdata.profile_picture,
            is_paid: userdata.is_paid,
            user_type: userdata.user_type,
            allow_notification: userdata.allow_notification,
            company_name: "",
            job_title: "",
            event_id: userdata.event_id,
            is_private: userdata.is_private,
            user_biography: "",
            facebook_profile: "",
            twitter_profile: "",
            linkedin_profile: "",
            portfolio_link: ""
       }

       CookieUtil.setCookie("user_info", JSON.stringify(data))
       localStorage.setItem('first_name', userdata.first_name)
       localStorage.setItem('last_name', userdata.last_name)
    }
   
  
    static convertToPlain = (html_code: string) => {
        // Create a new div element
        let tempDivElement = document.createElement("div");
    
        // Set the HTML content with the given value
        tempDivElement.innerHTML = html_code;
    
        // Retrieve the text property of the element
        return tempDivElement.textContent || tempDivElement.innerText || "";
      };

      static getPresentorPicture(agenda: ScheduleItem) {
         let profilePictureKey = _.get(agenda, "profile_picture.key", null);
        let gender  = _.get(agenda, "salutation", null);
        if(profilePictureKey){
          return  IMAGES_BASE_PATH + profilePictureKey
        }
        
          // Fallback to gender-based dummy images from public/assets
          if (gender?.toLowerCase() === "mr") {
            return "/images/dummy_man.jpeg"; 
           
          }
           return "/images/dummy_female.png";
         
      }
       static getPresentorProfession(event: any) {
        const jobTitle = _.get(event, "job_title", "");
        return jobTitle !== null ? jobTitle : "";
      }
      static getEventPresentor(event: any) {
        return `${_.get(event, "first_name", "")} ${_.get(event, "last_name", "")}`;
      }

      static getSpeakerPicture(agenda: ScheduleItem) {
         let profilePictureKey = _.get(agenda, "speaker.profile_picture.key", null);
        let gender  = _.get(agenda, "speaker.salutation", null);
        if(profilePictureKey){
          return  IMAGES_BASE_PATH + profilePictureKey
        }
        
          // Fallback to gender-based dummy images from public/assets
          if (gender?.toLowerCase() === "mr") {
            return "/images/dummy_man.jpeg"; 
           
          }
           return "/images/dummy_female.png";
         
      }
      static getPanelistPicture(agenda: ScheduleItem) {
        const profilePictureKey = _.get(agenda, "profile_picture.key", null);
        return profilePictureKey
          ? IMAGES_BASE_PATH + profilePictureKey
          :   "../images/dummy.jpeg";
         
      }
    
      static getModeratorPicture(agenda: ScheduleItem) {
        const profilePictureKey = _.get(agenda, "moderator.profile_picture.key", null);
        let gender  = _.get(agenda, "moderator.salutation", null);
        if(profilePictureKey){
          return  IMAGES_BASE_PATH + profilePictureKey
        }
        
          // Fallback to gender-based dummy images from public/assets
          if (gender?.toLowerCase() === "mr") {
            return "/images/dummy_man.jpeg"; 
           
          }
           return "/images/dummy_female.png";
        
        
      }
      static getEventTitleByName(translations) {
        const lang_name = this.getSelectedLanguageId();
        let langObject = _.find(translations, (i) => i.key === lang_name);
        return langObject?.name || "No Title Available";
      }
    
      static getEventTitle(translations?: Translation[]) {
        const lang_name = this.getSelectedLanguageId();
        let langObject = _.find(translations, (i) => i.key === lang_name);
        return langObject?.title || "No Title Available";
      }
    
      static getEventSpeaker(event: ScheduleItem) {
        return `${_.get(event, "speaker.first_name", "")} ${_.get(event, "speaker.last_name", "")}`;
      }
      static getSpeakerProfession(event: ScheduleItem) {
        const jobTitle = _.get(event, "speaker.job_title", "");
        return jobTitle !== null ? jobTitle : "";
      }
      static getModeratorProfession(event: ScheduleItem) {
        const jobTitle = _.get(event, "moderator.job_title", "");
        return jobTitle !== null ? jobTitle : "";
      }
      static getEventModerator(event: ScheduleItem) {
        return `${_.get(event, "moderator.first_name", "")} ${_.get(event, "moderator.last_name", "")}`;
      }
    
      static getEventDescription(agenda: ScheduleItem) {
        const lang_name = this.getSelectedLanguageId();
        const description = _.get(
          _.find(agenda.translations, (i) => i.key === lang_name),
          "description",
          "No Description"
        );
        return description;
        //return description.substring(0, 200);
      }
    
      static localTimeStrFromZone(scheduleTime?: string) {
        let offset = moment().utcOffset();
        return scheduleTime ? moment.utc(scheduleTime).utcOffset(offset).format("hh:mm A") : "Invalid Time";
      }

      static localDateStrFromZone(scheduleTime?: string) {
        let offset = moment().utcOffset();
        return scheduleTime ? moment.utc(scheduleTime).utcOffset(offset).format("DD.MM.YYYY") : "Invalid Time";
      }

    //   static localDateStrFromZone(scheduleTime?: string) {
    //     // Check if scheduleTime is provided
    //     if (!scheduleTime) {
    //         return "Invalid Time";
    //     }
    
    //     // Get the current UTC offset
    //     const offset = moment().utcOffset();
    
    //     // Convert the scheduleTime to local time using the current offset
    //     const localDate = moment.utc(scheduleTime).utcOffset(offset);
    
    //     // Format the date as "MMM D, YYYY"
    //     return localDate.format("MMM D, YYYY");
    // }

      static localTimeStrFromZoneWithDate(scheduleTime?: string) {
        var offset = moment().utcOffset();
        return scheduleTime ? moment.utc(scheduleTime).utcOffset(offset).format("MMM D,YYYY hh:mm A") : "Invalid Time";
      }

      static getEventHallSpeakerPicture(agenda: ScheduleItem) {
        const profilePictureKey = _.get(agenda, "speaker.profile_picture.key", null);
        return profilePictureKey
          ? IMAGES_BASE_PATH + profilePictureKey
          :   "../images/dummy.jpeg";
      }
      
      static downloadFile = (filename: string, content: string) => {
        const element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(content));
        element.setAttribute('download', filename);
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      };

      static getBoothExhbitor(booth:any) {
        console.log("booth",booth)
        const profilePictureKey = _.get(booth, "exhibitor_id.logo.key", null);
        return profilePictureKey
          ? IMAGES_BASE_PATH + profilePictureKey
          : "../images/dummy.jpeg";
      }
    

      
    

   
  }
  
  export default UserHelper;
  